import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Sparkles } from 'lucide-react';
export function PricingSection() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-110">
      <div className="max-w-5xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-113">
            Planes transparentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-114">
            Elige el nivel de apoyo que necesitas
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto items-center" data-id="element-115">
          {/* Plan Base */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm" data-id="element-116">
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-117">PLAN BASE</h3>
            <div className="flex items-baseline gap-1 mb-4" data-id="element-118">
              <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-119">
                $300.000
              </span>
            </div>
            <p className="text-gray-600 mb-8 h-12" data-id="element-120">
              Para quienes quieren hacerlo solos, pero bien
            </p>

            <ul className="space-y-4 mb-8" data-id="element-121">
              <li className="flex items-start gap-3" data-id="element-122">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-123" />
                <span className="text-gray-700" data-id="element-124">1 sesión estratégica</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-125">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-126" />
                <span className="text-gray-700" data-id="element-127">
                  Guía paso a paso (videos + checklist)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-128">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-129" />
                <span className="text-gray-700" data-id="element-130">Plantillas de publicación</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-131">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-132" />
                <span className="text-gray-700" data-id="element-133">
                  Revisión inicial del aviso
                </span>
              </li>

              <div className="pt-4 mt-4 border-t border-gray-100 space-y-4" data-id="element-134">
                <li className="flex items-start gap-3 opacity-50" data-id="element-135">
                  <X className="text-gray-400 shrink-0 mt-0.5" size={20} data-id="element-136" />
                  <span className="text-gray-500" data-id="element-137">
                    No incluye filtrado de leads
                  </span>
                </li>
                <li className="flex items-start gap-3 opacity-50" data-id="element-138">
                  <X className="text-gray-400 shrink-0 mt-0.5" size={20} data-id="element-139" />
                  <span className="text-gray-500" data-id="element-140">
                    No incluye acompañamiento continuo
                  </span>
                </li>
                <li className="flex items-start gap-3 opacity-50" data-id="element-141">
                  <X className="text-gray-400 shrink-0 mt-0.5" size={20} data-id="element-142" />
                  <span className="text-gray-500" data-id="element-143">
                    No incluye revisión de ofertas
                  </span>
                </li>
              </div>
            </ul>

            <button className="w-full py-3 px-6 rounded-xl font-medium text-brand-700 bg-brand-50 hover:bg-brand-100 transition-colors" data-id="element-144">
              Elegir Plan Base
            </button>
          </motion.div>

          {/* Plan Pro */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 border-2 border-brand-600 shadow-xl relative md:scale-105 z-10" data-id="element-145">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-600 text-white px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 shadow-sm" data-id="element-146">
              <Sparkles size={14} data-id="element-147" />
              Más elegido
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-148">PLAN PRO</h3>
            <div className="flex items-baseline gap-1 mb-4" data-id="element-149">
              <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-150">
                $700.000
              </span>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-151">
              Para quienes quieren vender mejor, sin perder tiempo
            </p>
            <p className="text-sm text-brand-700 font-medium bg-brand-50 rounded-lg px-3 py-2 mb-8" data-id="element-152">
              Nos encargamos de filtrar todos tus compradores y ordenar el
              proceso
            </p>

            <ul className="space-y-4 mb-8" data-id="element-153">
              <li className="flex items-start gap-3 font-medium" data-id="element-154">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-155" />
                <span className="text-gray-900" data-id="element-156">Todo lo del plan base</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-157">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-158" />
                <span className="text-gray-700" data-id="element-159">Publicación optimizada</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-160">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-161" />
                <span className="text-gray-700" data-id="element-162">
                  Recepción de todos los contactos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-163">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-164" />
                <span className="text-gray-700" data-id="element-165">
                  Filtro de compradores reales
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-166">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-167" />
                <span className="text-gray-700" data-id="element-168">Agenda de visitas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-169">
                <Check className="text-brand-600 shrink-0 mt-0.5" size={20} data-id="element-170" />
                <span className="text-gray-700" data-id="element-171">
                  Acompañamiento en visitas, ofertas y cierre
                </span>
              </li>
            </ul>

            <button className="w-full py-3 px-6 rounded-xl font-medium text-white bg-brand-600 hover:bg-brand-700 transition-colors shadow-sm hover:shadow-md" data-id="element-172">
              Elegir Plan Pro
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}